import { Button, Checkbox, FormControlLabel } from "@mui/material";
import { HistoricProps } from "../../../interfaces/props/SaudeBemEstar/MeuDiario/HistoricProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import './styles.css';
import parse from 'html-react-parser';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { useState } from "react";
import { sxButton } from "./sxProps";
import { useNavigate } from "react-router-dom";
import Terms from "../../../components/Terms";
import ModalTerms from "../../../components/ModalTerms";
import VoltarButton from "../../../components/Accessibility/VoltarButton";

function Historic(props: HistoricProps) {
    const [notShow, setNotShow] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const accessibility = useAccessibility();
    const navigate = useNavigate(); 

    const handleDontShow = () => {
        setNotShow(!notShow)
    }

    const handleHistoric = () => {
        if(props.acceptTerm.indAceite === 'N'){
            setOpen(true);
        }
        else {
            navigate("/saudeBemEstar/unimedAcolhe/meuDiario/sintomas", { replace: true });
            props.handleHistoric(false, notShow);
        }
    }

    const handleTermsOfUse = (accept: boolean) => {
        if(accept){
            setOpen(false);
            navigate("/saudeBemEstar/unimedAcolhe/meuDiario/sintomas", { replace: true });
            props.handleHistoric(true, notShow);
        }
        else {
            setOpen(false);
        }
    }

    const closeTermsOfUse = () => {
        setOpen(false);
    }

    const handleBack = () => {
        navigate("/saudeBemEstar/unimedAcolhe/meuDiario/inicio", { replace: true });
        props.handleHistoricBack();
    }

    return (
        <div className="my-diary-holder">
            <ModalTerms open={open} handleTermsOfUse={handleTermsOfUse} terms={props.term} closeTermsOfUse={closeTermsOfUse}/>
            <h1 className="my-diary-subtitle" style={accessibility.textTitleStyleAccessibility}>Histórico</h1>
            <p className="my-diary-infos">{props.diary.details[1].diarioTexts[0].texto}</p>
            <p className="my-diary-infos">{props.diary.details[1].diarioTexts[1].texto}</p>
            <div className="checkboxes-holder">
                {props.diary.details[1].diarioTexts[1].diarioTextsLi.map((item) => {
                    return (
                        <div className="my-diary-check-icon-row">
                            <div className={`check-icon ${!accessibility.contrastMode ? 'normal-mode' : 'contrast-mode' }`} >
                                <FontAwesomeIcon style={accessibility.checkboxStyleAccessibility} icon={faCheck} size='xs'/>
                            </div>
                            <span className="my-diary-check-text">{item.texto}</span>
                        </div>
                    )
                })}
            </div>
            <p className="my-diary-infos">{parse(props.diary.details[1].diarioTexts[2].texto)}</p>
            <div className="my-diary-registration-button">
                <Button
                    variant="contained"
                    size="large"
                    onClick={handleHistoric}
                    sx={sxButton}
                    style={{...accessibility.buttonStyleAccessibility, ...accessibility.buttonTextStyleAccessibility}}
                    fullWidth>
                    NOVO REGISTRO
                </Button>
            </div>
            
            <FormControlLabel control={
                <Checkbox onChange={handleDontShow} style={accessibility.contrastColorAccessibility}/>
                } 
                label="Não exibir esta mensagem novamente"
            />
            <VoltarButton onClick={handleBack} />
        </div>
    )
}

export default Historic;